<template>
  <div class="block">
    <el-date-picker
      v-model="result"
      :editable="false"
      :type="dateType"
      align="right"
      unlink-panels
      :range-separator="'-'"
      :start-placeholder="$t('407')"
      :end-placeholder="$t('408')"
      :default-time="defaultTime"
      :picker-options="pickerOptions"
      :clearable="clear"
      :value-format="valueFormat"
      :format="format"
      @blur="minDate = ''"
      :popper-class="isShowHeader ? 'date-pic' : ''"
    ></el-date-picker>
  </div>
</template>

<script>
let self

const now = new Date()
const nowMonth = now.getMonth()
let nowYear = now.getYear()
nowYear += nowYear < 2000 ? 1900 : 0
const lastMonthDate = new Date()
lastMonthDate.setDate(1)
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
const lastMonth = lastMonthDate.getMonth()

const getDateStr = v => {
  const nowDate = new Date().getTime()
  const targetDate = new Date(nowDate)
  const dd = targetDate
  dd.setDate(dd.getDate() + v)
  const y = dd.getFullYear()
  const m = dd.getMonth() + 1
  const d = dd.getDate()
  return `${y}-${m}-${d}`
}

const formatDate = date => {
  const myyear = date.getFullYear()
  let mymonth = date.getMonth() + 1
  let myweekday = date.getDate()
  if (mymonth < 10) {
    mymonth = `0${mymonth}`
  }
  if (myweekday < 10) {
    myweekday = `0${myweekday}`
  }
  return `${myyear}-${mymonth}-${myweekday}`
}

const getMonthDays = myMonth => {
  const monthStartDate = new Date(nowYear, myMonth, 1)
  const monthEndDate = new Date(nowYear, myMonth + 1, 1)
  const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
  return days
}
const getMonthStartDate = () => {
  const monthStartDate = new Date(nowYear, nowMonth, 1)
  return formatDate(monthStartDate)
}
const getMonthEndDate = () => {
  const monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth))
  return formatDate(monthEndDate)
}
const getLastMonthStartDate = () => {
  let lastMonthStartDate = null
  if (lastMonth === 11) {
    lastMonthStartDate = new Date(nowYear - 1, lastMonth, 1)
  } else {
    lastMonthStartDate = new Date(nowYear, lastMonth, 1)
  }
  return formatDate(lastMonthStartDate)
}
const getLastMonthEndDate = () => {
  let lastMonthEndDate = null
  if (lastMonth === 11) {
    lastMonthEndDate = new Date(nowYear - 1, lastMonth, getMonthDays(lastMonth))
  } else {
    lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth))
  }
  return formatDate(lastMonthEndDate)
}
export default {
  props: {
    clear: {
      default: true,
      type: Boolean
    },
    isShowHeader: {
      default: false,
      type: Boolean
    },
    defaultValue: Array,
    // 该处待修改-无bug，只是有点不符预期
    dateType: {
      default: 'datetimerange',
      type: String
    },
    defaultTime: {
      type: Array,
      default: () => ['00:00:00', '23:59:59']
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    chooseRange: {
      type: [String, Number],
      default: 30
    }
  },
  watch: {
    defaultValue: {
      handler(v) {
        if (v) this.result = v
      },
      immediate: true,
      deep: true
    },
    clear(v) {
      if (v) this.result = null
    },
    result(v) {
      if (v) {
        const [start, end] = v
        this.$emit('input', [start, end])
      } else {
        this.$emit('input', v)
      }
    }
  },
  computed: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: this.$t('720'),
            onClick(picker) {
              const today = getDateStr(0)
              const start = new Date(new Date(today).setHours(0, 0, 0, 0))
              const end = new Date(new Date(today).setHours(23, 59, 59, 59))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('721'),
            onClick(picker) {
              const yesterday = getDateStr(-1)
              const start = new Date(new Date(yesterday).setHours(0, 0, 0, 0))
              const end = new Date(new Date(yesterday).setHours(23, 59, 59, 59))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('722'),
            onClick(picker) {
              const beforeYesterday = getDateStr(-2)
              const start = new Date(new Date(beforeYesterday).setHours(0, 0, 0, 0))
              const end = new Date(new Date(beforeYesterday).setHours(23, 59, 59, 59))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('723'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(new Date(getDateStr(-7)).setHours(0, 0, 0, 0)),
                new Date(new Date(getDateStr(0)).setHours(23, 59, 59, 59))
              ])
            }
          },
          {
            text: this.$t('724'),
            onClick(picker) {
              const startMouth = getMonthStartDate()
              const endMouth = getMonthEndDate()
              const start = new Date(new Date(startMouth).setHours(0, 0, 0, 0))
              const end = new Date(new Date(endMouth).setHours(23, 59, 59, 59))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('725'),
            onClick(picker) {
              const lastStartMouth = getLastMonthStartDate()
              const lastEndMouth = getLastMonthEndDate()
              const start = new Date(new Date(lastStartMouth).setHours(0, 0, 0, 0))
              const end = new Date(new Date(lastEndMouth).setHours(23, 59, 59, 59))
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate(time) {
          const daySeconds = 86400000
          const curSelectTime = new Date(self.minDate).getTime()
          const before = curSelectTime - daySeconds * Number(self.chooseRange)
          // after 时间戳导致，不能都已0点起算，否则会导致可选范围内最后一天不可选择
          const after = curSelectTime + 86399999 + daySeconds * Number(self.chooseRange)
          return time.getTime() > after || time.getTime() < before
        },
        onPick({ maxDate, minDate }) {
          if (!maxDate) {
            self.minDate = minDate
          }
        }
      }
    }
  },
  created() {
    self = this
  },
  data() {
    return {
      result: '',
      minDate: ''
    }
  }
}
</script>
<style>
.date-pic .el-date-range-picker__time-header {
  display: none;
}
</style>
